import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { Background } from "./BackgroundSettings";
import useVariableValues from "../../hooks/useVariableValues";
import { useAppSelector } from "@/hooks";
import { getThumbnailImage } from "@/utils/media";

const PROPS: (keyof Background)[] = ["backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "backgroundAttachment"];

const useNormalizeBackground = (props) => {
  const vv = useVariableValues(true);
  const responsive = useResponsiveValues();
  const organizationId = useAppSelector((store) => store.ui.activeOrganization);

  const draft = useMemo(() => {
    const draft: Background = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);

        if (prop === "backgroundImage") {
          const image = vv.getValue(value ?? "");
          const isFromTemplate = image?.startsWith('http');

          if (isFromTemplate) {
            draft.backgroundImage = `url(${image})`;
          } else {
            const imageUrl = getThumbnailImage({ file: image, organizationId, size: "800x500" });
            draft.backgroundImage = `url(${imageUrl})`;
          }
        } else if (prop === "backgroundColor") {
          draft[prop] = vv.getValue(value ?? "");
        } else {
          draft[prop] = value;
        }
      }
    });

    return draft;
  }, [organizationId, props, responsive, vv]);
  return draft;
};

export default useNormalizeBackground;
